import { useAppDispatch, useAppSelector } from "../app/hooks";
import { toggleAgreed, setEmail, setUserName, saveUserData } from "../app/slices/appSlice";
import { Button } from "./Button";
import { CommonState } from "../app/interfaces/common";
import { ReactElement } from "react";
import { giEvent, ymEvent } from "../app/utils/metrix";

export const Auth = (): ReactElement => {
  const dispatch = useAppDispatch()
  const { username, email, agreed } = useAppSelector((state: CommonState) => state.app)
  const next = () => {
    giEvent('Otprav_anketa');
    ymEvent('authorization_screen_start_click');
    dispatch(saveUserData({ email: email, name: username }))
  }
  return (
    <div className={'rules rel'}>
      <div className={'pb_auth bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Чтобы начать, нужно авторизоваться</h1>
        <form>
          <input className={'input'} maxLength={30} placeholder="Имя" type={'text'}
                 onKeyUp={(e) => dispatch(setUserName(e.currentTarget.value))}/>
          <input className={'input'} maxLength={30} placeholder="Почта" type={'text'}
                 onKeyUp={(e) => dispatch(setEmail(e.currentTarget.value))}/>
          <div className={'checkbox__wrap'}>
            <div className={'checkbox'} onClick={(e) => dispatch(toggleAgreed())}>
              {agreed && <div className={'checked'}/>}
            </div>
            <div className={'checkbox__text'} onClick={(e) => dispatch(toggleAgreed())}>Я согласен на обработку
              персональных данных
            </div>
          </div>
        </form>
        <div className={'rules__gears'}/>
      </div>
      <div className={'auth__machine-wrap'}>
        <div className={'auth__machine'}></div>
      </div>
      {username !== '' && email !== '' && email.includes('@') && agreed &&
          <Button cssClass={'button_green button_auth'} clickEvent={() => next()}>Начать</Button>}
    </div>
  )
}